import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorMasterInventoryCategoryView = () => {
  const masterInventoryCategoryView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/master-inventory/category-view', payload, (response) => {
      if (response.code === 7200 && response.data) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          redirect: '/administrator/master/inventory-category/manage',
        })
      }
      loading(false)
    })
  }, [])
  return { masterInventoryCategoryView }
}

export default InteractorMasterInventoryCategoryView
